import React, { createContext, useContext, useMemo } from "react";
import { useBrowserPhone } from "./useBrowserPhone";

const BrowserPhoneContext = createContext(null);

export const BrowserPhoneProvider = ({ children }) => {
  const phone = useBrowserPhone();
  const value = useMemo(() => phone, [phone]);
  return <BrowserPhoneContext.Provider value={value}>{children}</BrowserPhoneContext.Provider>;
};

export const useBrowserPhoneContext = () => {
  const context = useContext(BrowserPhoneContext);
  if (!context) {
    throw new Error("useBrowserPhoneContext must be used inside BrowserPhoneProvider");
  }
  return context;
};
